import React, { useEffect, useState } from "react";
import {
  Offcanvas,
  Button,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  DisplaySettingsOutlined,
  VisibilityOutlined,
  DeleteForeverOutlined,
  ErrorOutline,
} from "@mui/icons-material";
import useSectionClients from "../../hooks/useSectionClients";
import SidebarSectionClients from "../../components/pgi/SidebarSectionClients";
import SidebarSectionClientsEdit from "../../components/pgi/SidebarSectionClientsEdit";
import { toast } from "react-hot-toast";
import Clientes from "../Clientes";

const SectionsClientsPgi = () => {
  const [showNewsHome, setShowNewsHome] = useState(true);
  const handleClose = () => setShowNewsHome(false);
  const handleShow = () => setShowNewsHome(true);

  const { multimedias, obtenerMultimedia, editMultimedia } = useSectionClients();

  useEffect(() => {
    obtenerMultimedia();
  }, []);

  useEffect(() => {
    document.title = "Personalizar Sección Clientes | PGI Tensolite"; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = (id, institucional) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">
          ¿Estas seguro de eliminar esta noticia?
        </div>
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmDelete(id, institucional)}
          >
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000,
      }
    );
  };

  const handleConfirmDelete = (id, institucional) => {
    // Encuentra el índice del objeto en la lista 'products' o 'others' que quieres modificar
    const productIndex = multimedias[0]?.products.findIndex(
      (product) => product._id.toString() === id
    );
    const othersIndex = multimedias[0]?.others.findIndex(
      (other) => other._id.toString() === id
    );

    let productsEdit;
    let othersEdit;
    let objectProducts;
    let objectOthers;

    if (productIndex !== -1) {
      productsEdit = multimedias[0]?.products?.filter(
        (noticia) => noticia._id !== id && noticia)
         objectProducts = {
          products: [...productsEdit],
          _id: multimedias[0]?._id,
          others: [...multimedias[0]?.others],
        };
    } else if (othersIndex !== -1) {
      othersEdit = multimedias[0]?.others?.filter(
        (noticia) => noticia._id !== id && noticia)
         objectOthers = {
          products: [...multimedias[0]?.products],
          _id: multimedias[0]?._id,
          others: [...othersEdit],
        };
    } 



    editMultimedia(institucional ? objectOthers : objectProducts);
    toast.dismiss();
  };

  return (
    <div id="wrapperEditClientes" className="wrapperPgi">
      <button onClick={handleShow} className="basePgi__setttings-button">
        <DisplaySettingsOutlined />
      </button>
      <div className="card container containerPgi">
        <Clientes />
      </div>

      {/* OFFCANVAS SETTING HOME*/}
      <Offcanvas
        show={showNewsHome}
        onHide={handleClose}
        placement="start"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Clientes</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form id="formEditarHSlider" className="basePgi__vista-edit-gral">
            {/* NOTICIAS */}

            <header aria-labelledby="formEditarHSlider">
              <h2>Archivos Multimedia Productos</h2>
              <SidebarSectionClients />
            </header>
            <Table responsive className="basePgi__table-list" hover>
              <colgroup>
                <col span="1" className="basePgi__table-col-min" />
                <col span="1" className="basePgi__table-col-max" />
                <col span="4" className="basePgi__table-col-min" />
              </colgroup>
              <tbody>
                {multimedias?.map(
                  (multimedia, index) =>
                    !multimedia?.deleted &&
                    multimedia?.products?.map((product) => (
                      <tr key={product?._id}>
                        <td>{product?.name}</td>
                        <td></td>
                        <td>
                          {/* <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                          >
                            <Button
                              className={noticia.visible ? "" : "disabled"}
                            >
                              {" "}
                              <VisibilityOutlined />{" "}
                            </Button>
                          </OverlayTrigger> */}
                        </td>
                        <td>
                          <Button>
                            <SidebarSectionClientsEdit
                              key={product?._id}
                              multimedia={product}
                            />
                          </Button>
                        </td>
                        <td onClick={() => handleDelete(product?._id)}>
                          {/* acción--> ELIMINA PUBLICACIÓN */}
                          <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Eliminar</Tooltip>}
                          >
                            <Button>
                              <DeleteForeverOutlined />
                            </Button>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </Table>
            <header aria-labelledby="formEditarHSlider">
              <h2>Archivos Multimedia Institucional</h2>
              <SidebarSectionClients institucional={true} />
            </header>
            <Table responsive className="basePgi__table-list" hover>
              <colgroup>
                <col span="1" className="basePgi__table-col-min" />
                <col span="1" className="basePgi__table-col-max" />
                <col span="4" className="basePgi__table-col-min" />
              </colgroup>
              <tbody>
                {multimedias?.map(
                  (multimedia, index) =>
                    !multimedia?.deleted &&
                    multimedia?.others.map((other) => (
                      <tr key={other?._id}>
                        <td>{other?.name}</td>
                        <td></td>
                        <td>
                          {/* <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                          >
                            <Button
                              className={noticia.visible ? "" : "disabled"}
                            >
                              {" "}
                              <VisibilityOutlined />{" "}
                            </Button>
                          </OverlayTrigger> */}
                        </td>
                        <td>
                          <Button>
                            <SidebarSectionClientsEdit
                              key={other?._id}
                              multimedia={other}
                              institucional={true}
                              otherInstitucional={true}
                            />
                          </Button>
                        </td>
                        <td onClick={() => handleDelete(other?._id, {institucional:true})}>
                          {/* acción--> ELIMINA PUBLICACIÓN */}
                          <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Eliminar</Tooltip>}
                          >
                            <Button>
                              <DeleteForeverOutlined />
                            </Button>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </Table>
            <button
              type="button"
              className="settings_button-pleno"
            >
              Guardar cambios
            </button>
          </form>

          {/****************end form módulos *************************** */}
        </Offcanvas.Body>
      </Offcanvas>
      {/*offC slides */}
    </div>
  );
};

export default SectionsClientsPgi;
